<template>
<div>
  <b-col xs=11 lg=9 md=10 sm=11 center >
  <!-- <h1>Home</h1> -->
  <!--<b-img center :src="require('../assets/award.png')" fluid width="70rem" class="imagens"></b-img> -->
  <p></p>
  <h2 class="impacto">Sistema Complementar para Contabilidade</h2>
  <p class="texthome">Da NFe ao EFD, tudo o que a empresa e o contabilista precisam para sua relação. </p>
  
  <h2 class="impacto">Você...</h2>
  <b-row xs=1 lg=2 md=2 sm=1 center >
  <p class="texthome"> <b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> É contabilista </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Já utiliza um sistema informatizado </p>
  </b-row>
  <p class="explic">O sistema Pergamin nfpoa permite a interação direta do seu cliente, através da geração das NFs e dos lançamentos dos movimentos (dados, imagens de pagamentos efetuados, etc.), de forma que tudo isso possa ser utilizado diretamente pelo seu sistema fiscal preferido. 
    Proporciona um ambiente organizado para o seu cliente gerar as notas fiscais. A EFD, que normalmente exige um grande trabalho de extração manual dos textos de discriminação das NFs de serviço, é gerada automaticamente.</p>
  
  <h2 class="impacto">Sua empresa...</h2>
  <b-row xs=1 lg=2 md=2 sm=1 center >
  <p class="texthome"> <b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Precisa emitir Notas Fiscais de serviços prestados em Porto Alegre  </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Quer fazer isso sem necessidade de downloads </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Sem instalação de programas  </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Sem instalação de certificados digitais no seu computador </p>
  </b-row>
  <p class="explic"> Com o sistema Pergamin nfpoa, você cria, registra na Prefeitura, imprime e envia Notas Fiscais, gera guias para pagamento dos impostos federais e até a Escrituração Fiscal Digital (EFD), tudo através da internet. Sua tecnologia exclusiva dispensa a instalação do seu certificado digital ou de qualquer programa no seu computador. </p>
  <!--<b-col class="text-center"><b-button size="lg" href="http://pergamin.com.br" pill variant="outline-secondary">Saiba mais sobre o Pergamin</b-button></b-col> -->
  
  <h2 class="impacto">Adaptado ao novo normal</h2>
    <b-row xs=1 lg=2 md=2 sm=1 center >
  <p class="texthome"> <b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img>  Implantação totalmente remota  </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Possibilita trabalho remoto dos colaboradores do contabilista </p>
  </b-row>
  <p class="explic">O sistema Pergamin nfpoa pode ser implantado totalmente de maneira remota, sem atividades presenciais. 
    As tarefas podem ser feitas no sistema de qualquer local, via internet, permitindo o home-office dos colaboradores do contabilista. </p>

  <h2 class="impacto">Outras vantagens</h2>
  <b-row xs=1 lg=2 md=2 sm=1 center >
  <p class="texthome"> <b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Adaptado ao uso em tablets e smartphones   </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Veja o resumo das notas fiscais no seu smartphone via código QR </p>  
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Preveja como a nota fiscal vai ficar antes de emiti-la </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Aproveite suas notas emitidas como modelo para novas notas.  </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img>  Notas Fiscais emitidas em papel e no site da Prefeitura podem ser registradas no sistema  </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Cálculo de impostos, Guias de Pagamento (DARFs) e EFD gerados automaticamente </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Cadastro de clientes compartilhado entre filiais da mesma empresa </p>
  <p class="texthome"><b-img :src="require('../assets/marca_v.svg')" fluid width="40pt" class="marcav" alt="caixa selecionada"></b-img> Baixo custo mensal, vantajoso inclusive para quem tem pouca quantidade de notas fiscais a emitir </p>
  </b-row>
  <p class="explic"> 
   Antes de emitir cada Nota Fiscal, você pode utilizar o modo de Simulação, que testa inclusive a transmissão para a Prefeitura, 
   e ver exatamente como a Nota vai ficar. Os dados das Notas Fiscais ficam armazenados, e você pode aproveitá-los como modelo para novas 
   notas. Inclusive as suas Notas Fiscais emitidas por outros meios (papel, site da Prefeitura), podem ser registradas no sistema. 
   O cálculo, totalização de impostos, geração de Guias de Pagamento (DARFs) e geração de arquivo de EFD para transmissão à Receita Federal 
   são automáticos. O cadastro de clientes compartilhado entre as filiais da empresa, e a possibilidade de cadastro prévio de serviços, agilizam o preenchimento de novas Notas Fiscais.


  </p>

  <h2 class="impacto">Vamos lá! Como funciona?</h2>
  <!--<b-row xs=1 lg=2 md=2 sm=1 center > -->
  <p class="texthome"> Este sistema é fornecido mediante retribuição mensal.</p>
  <p class="texthome"> Dependendo da necessidade da empresa, fornecemos versões em servidor compartilhado, sem custo inicial (exceto assessoria/treinamento, se necessário). Consulte opções para site próprio, servidor próprio na sua empresa ou servidor dedicado na nuvem.</p>
  <p class="texthome"> Contabilistas podem adquirir licenças para utilizar o sistema em um ou mais clientes, com condições especiais. A versão para contabilistas permite que ofereçam aos seus clientes serviços extra de valor agregado, como auxílio remoto no preenchimento de dados para NFs.</p>
  <p class="texthome"> É necessário certificado digital tipo A1 (arquivo .pem ou .pfx), que pode ser adquirido em qualquer autoridade certificadora brasileira. Grande parte das empresas de Porto Alegre já possui um certificado digital.</p>
  <!--</b-row> -->
  
  <h2 class="impacto">Quero saber mais!</h2>
  <p class="texthome"> Deixe seu e-mail para entrarmos em contato:</p>

   <ValidationObserver ref="observer">
    <b-form 
    slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)" @reset="onReset"
    >

    <b-container class="row no-gutters">
    <b-col xs=4 lg=3 md=4 sm=4>
    <ValidationProvider rules="alpha_spaces" name="Name">
      <b-form-group
        id="input-group-1"
        label=""
        label-for="input-1"
        slot-scope="{ valid, errors }"
      >
     <b-form-input
          id="input-1"
          v-model="form.name"
          type="text"
          required
          placeholder="Nome"
          :state="errors[0] ? false : (valid ? true : null)"
        ></b-form-input>
      </b-form-group> 
      </ValidationProvider>
    </b-col>  
    <b-col xs=7 lg=5 md=6 sm=6>
    <ValidationProvider rules="required|email" name="Email">
      <b-form-group
        id="input-group-2"
        label=""
        label-for="input-2"
        slot-scope="{ valid, errors }"
      >
     <b-form-input
          id="input-2"
          v-model="form.email"
          type="email"
          required
          placeholder="Endereço de e-mail"
          :state="errors[0] ? false : (valid ? true : null)"
        ></b-form-input>
      </b-form-group> 
      </ValidationProvider>
      </b-col>
      <b-col>
      <b-button :disabled="sending" type="submit" variant="light">Enviar</b-button>
       <!--<b-button type="reset" variant="outline-light">Limpar</b-button>-->
      </b-col>
      </b-container>
 <!--
      <b-form-group id="input-group-5" label-for="input-5" label="Sou:" required>
        <b-form-radio v-model="form.porque" name="select2" value="contador">Contador(a)</b-form-radio>
        <b-form-radio v-model="form.porque" name="select2" value="empresario">Empresário(a)</b-form-radio>
        <b-form-radio v-model="form.porque" name="select2" value="empreendedor">Empreendedor(a)</b-form-radio>
        <b-form-radio v-model="form.porque" name="select2" value="Outros">Outro</b-form-radio>
      </b-form-group>
      size="invisible" 6Ld50zcaAAAAAGoXtVzZLfzLVuqpSHZPWxm9O7f1"6Lda1zcaAAAAAH3P1us2gb941S54jwGNx6qytXh0"
      -->
      <b-col xs=4 lg=3 md=4 sm=4>
       <!-- <div class="g-recaptcha" data-sitekey="6Lda1zcaAAAAAH3P1us2gb941S54jwGNx6qytXh0"></div>-->
        
      <vue-recaptcha
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        sitekey="6LcR2zcaAAAAAO9b74ySLx7XqZkwCqTqvDnPVTTv"
        size="invisible"
      ></vue-recaptcha>
      
      </b-col>

      </b-form>
      </ValidationObserver>



  <p class="explic"> Ou, se preferir, solicite maiores informações através do e-mail info@pergamin.com.br ou no formulário de contato do <a class="explic" href="http://lucchese.com.br">site da nossa empresa</a>. </p>
</b-col>
</div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import VueRecaptcha from "vue-recaptcha";
import api from "../services/api";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha,
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        porque: "Outro",
        
      },
      show: true,
      sending: false
    };
  },
  methods: {
    onSubmit () {
      this.sending = true;
      this.$refs.recaptcha.execute();
      console.log(JSON.stringify(this.form));
      //alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.porque = "";
      //this.form.ligacao = ""
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    onCaptchaVerified: function (recaptchaToken) {
    this.$refs.recaptcha.reset();
    api
        .post("/nfpoamailer/", {
          email: this.form.email,
          porque: this.form.porque,
          name: this.form.name,
          recaptchaToken: recaptchaToken,
        })
        .then((response) => {
          this.sending=false;
          if(response.status==200){
            alert("Aguarde nosso contato em breve.");
          }else{
            alert("Houve um erro. Por favor, tente novamente.");
          }
        })
        .catch((err) => {
          this.sending=false;
          alert("Houve um erro. Por favor, tente novamente.");
          console.log(err);
        });
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    },
  },
};
</script>

<style>
.imagens {
  padding-top: 2vh;
  padding-bottom: 2vh;
}
.marcav {
  padding-top: 0vh;
  padding-bottom: 0vh;
  padding-left: 2vh;
}
.texthome{
 color: rgb(100, 100, 100);
 font-size: 1.1rem;
 font-style: normal;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
 text-align: left;
 line-height: 1em;
}
.linkhome{
 color: rgb(100, 100, 100);
 font-size: 1.5rem;
 text-decoration: underline;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
}
.descricao{
 color: rgb(100, 100, 100);
 font-size: 0.8rem;
 font-style: normal;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
 text-align: left;
}
.explic{
 color: rgb(80, 80, 80);
 font-size: 0.9rem;
 font-style: normal;
 font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
 text-align: justify;
}
.impacto{
 color: rgb(00, 00, 00);
 font-size: 1.3rem;
 font-style: italic;
 font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
 text-align: left;
}
</style>